import React from "react";
import { Link } from "react-router-dom";

/**
 * Fixed marketing nav — solid page navy (no translucent/blur seam above content).
 * @param {{ stacked?: boolean }} props — when true, parent is the fixed header stack (no own fixed positioning).
 */
export default function PublicSiteNav({ stacked = false }) {
  return (
    <nav
      aria-label="Primary"
      className={
        stacked
          ? "bg-[#0B1437] pt-[env(safe-area-inset-top)] shadow-none backdrop-blur-none"
          : "fixed inset-x-0 top-0 z-50 bg-[#0B1437] pt-[env(safe-area-inset-top)] shadow-none backdrop-blur-none"
      }
    >
      <div className="mx-auto flex w-full max-w-6xl flex-nowrap items-start justify-between gap-2 px-5 py-3">
        <div className="flex min-w-0 flex-1 items-start gap-2 overflow-x-auto sm:gap-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <div className="flex shrink-0 flex-col gap-2">
            <Link
              to="/"
              className="rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-center text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
            >
              Home
            </Link>
            <Link
              to="/Contest/RefferalContest"
              className="rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-center text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
            >
              Contest
            </Link>
          </div>
          <div className="flex min-w-0 flex-nowrap items-start gap-2 sm:gap-3">
          <Link
            to="/AboutUs"
            className="shrink-0 rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
          >
            About Us
          </Link>
          <Link
            to="/Pricing"
            className="shrink-0 rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
          >
            Pricing
          </Link>
          <Link
            to="/Results"
            className="shrink-0 rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
          >
            Results
          </Link>
          <Link
            to="/ContactUs"
            className="shrink-0 rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
          >
            Contact Us
          </Link>
          <Link
            to="/HowItWorks"
            className="shrink-0 rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
          >
            How it works
          </Link>
          <Link
            to="/FrequentlyAskedQuestions"
            className="shrink-0 rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
          >
            FAQ
          </Link>
          </div>
        </div>
        <div className="flex shrink-0 flex-nowrap items-start gap-2 sm:gap-3">
          <Link
            to="/SignUp"
            className="shrink-0 rounded-xl bg-brand-500 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-600 active:bg-brand-700 sm:px-6 sm:py-3 sm:text-base"
          >
            SignUp
          </Link>
          <Link
            to="/SignIn"
            className="shrink-0 rounded-xl border border-white/25 bg-white/5 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:px-6 sm:py-3 sm:text-base"
          >
            SignIn
          </Link>
        </div>
      </div>
    </nav>
  );
}
